module.exports = __webpack_public_path__ + "cd763acfaa37bd3b5b500a157c6e03d7.png";